import { TextBox, TextBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../state/standardLoanStore';
import { isRequiredOnceNoteDated } from '../functions/isRequiredOnceNoteDated';

/** Digits only, no leading zeros, up to 8 characters. */
export const LoanNumberField = () => {
    /** Loan #: digits only with no leading zeros; '0' becomes empty (same cleaning as the existing LoanNumber input). */
    const cleanLoanNumber = (input: string | undefined) => {
        const digits = (input ?? '').replace(/[^0-9]/g, '');
        if (!digits || digits === '0' || isNaN(Number(digits))) {
            return '';
        }
        return parseInt(digits, 10).toString();
    };

    const setup = useStandardLoanStore((state) => state.setup);
    const updateSetup = useStandardLoanStore((state) => state.updateSetup);

    return (
        <TextBox
            id='setupLoanNumber'
            value={setup.loanNumber}
            onChange={(loanNumber) => updateSetup({ loanNumber: cleanLoanNumber(loanNumber) })}
            label='Loan #'
            required={isRequiredOnceNoteDated(setup)}
            maxLength={8}
            width='100%'
            height='36px'
            layoutStyle={TextBoxLayoutStyle.Horizontal}
            labelWidth='60px'
        />
    );
};
